export function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

export const toNumber = <T = unknown>(value: T, fallbackNumber = 0) => {
  try {
    const parsed = Number(value);

    return isNaN(parsed) ? fallbackNumber : parsed;
  } catch (error) {
    return fallbackNumber;
  }
};
